// src/DoctorModal.js

import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react'; // Ci serve per il bottone di eliminazione eccezioni

const modalStyles = {
    position: 'fixed', zIndex: 2001, left: 0, top: 0, width: '100%', height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center'
};
const modalContentStyles = {
    backgroundColor: '#fefefe', padding: '25px', border: '1px solid #888',
    width: '90%', maxWidth: '600px', borderRadius: '12px', maxHeight: '90vh', overflowY: 'auto'
};
const inputStyle = { width: '100%', padding: '10px', fontSize: '0.95rem', boxSizing: 'border-box', border: '1px solid #ccc', borderRadius: '5px' };
const labelStyle = { display: 'block', fontWeight: '600', marginBottom: '5px', fontSize: '0.85rem', color: '#4b5563' };

export function DoctorModal({ doctorData, allSpecialties, allServices = [], onSave, onClose, isProfileMode = false }) { // 🎯 FIX: Aggiunta prop isProfileMode
    const [activeTab, setActiveTab] = useState('base'); // 'base' | 'clinico' | 'economico'

    // Dati Base
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [pIva, setPIva] = useState('');
    const [iban, setIban] = useState('');
    const [colore, setColore] = useState('#3b82f6'); // 🆕 Aggiunto lo stato del colore (Blu di default)
    const [selectedSpecialtyIds, setSelectedSpecialtyIds] = useState([]);
    const [searchTermSpec, setSearchTermSpec] = useState('');

    // Dati Clinici e Compensi
    const [isBookable, setIsBookable] = useState(true);
    const [percentualeManuale, setPercentualeManuale] = useState(50);
    const [percentualeStrumentale, setPercentualeStrumentale] = useState(30);
    const [prestazioniAssegnate, setPrestazioniAssegnate] = useState([]);
    const [eccezioniListino, setEccezioniListino] = useState({});
    // 🆕 Categorie diagnostica refertabili
const [categorieRefertazione, setCategorieRefertazione] = useState([]);
    
    // Stati per nuova eccezione
    const [newExceptionServiceId, setNewExceptionServiceId] = useState("");
    const [newExceptionPercentage, setNewExceptionPercentage] = useState("");

    // 🎯 NUOVI STATI: Modello di Compenso
    const [paymentType, setPaymentType] = useState('percentage'); // 'percentage' | 'hourly' | 'fixed'
    const [baseRate, setBaseRate] = useState(''); // Valore orario o fisso mensile
    const [percentageExceptions, setPercentageExceptions] = useState([]); // Array di ID dei servizi eccezione

    useEffect(() => {
        if (doctorData) {
            setFirstName(doctorData.firstName || '');
            setLastName(doctorData.lastName || '');
            setSelectedSpecialtyIds(doctorData.specialtyIds || []);
            setEmail(doctorData.email || '');
            setPIva(doctorData.pIva || '');
            setIban(doctorData.iban || '');
            setColore(doctorData.color || doctorData.colore || '#3b82f6'); // 🆕 Pre-carica il colore salvato
            
            setIsBookable(doctorData.isBookable !== false); // Default true
            setPercentualeManuale(doctorData.percentualeManuale ?? 50);
            setPercentualeStrumentale(doctorData.percentualeStrumentale ?? 30);
            setPrestazioniAssegnate(doctorData.prestazioniAssegnate || []);
            setEccezioniListino(doctorData.eccezioniListino || {});
            setCategorieRefertazione(doctorData.categorieRefertazione || []);
            setPaymentType(doctorData.paymentType || 'percentage');
            setBaseRate(doctorData.baseRate || '');
            setPercentageExceptions(doctorData.percentageExceptions || []);
        }
    }, [doctorData]);

    const handleSave = () => {
        if (!firstName || !lastName) { alert('Nome e Cognome sono obbligatori.'); return; }
        onSave({
            id: doctorData?.id,
            firstName: firstName.trim(),
            lastName: lastName.trim(),
            specialtyIds: selectedSpecialtyIds,
            email: email.trim() || undefined,
            pIva: pIva.trim() || undefined,
            iban: iban.trim() || undefined,
            
            color: colore,   // 🆕 Aggiunto: Chiave in inglese (probabilmente quella attesa dal DB)
            colore: colore,  // 🆕 Aggiunto: Chiave in italiano per sicurezza e retrocompatibilità
            
            isBookable: isBookable,
            percentualeManuale: parseFloat(percentualeManuale) || 0,
            percentualeStrumentale: parseFloat(percentualeStrumentale) || 0,
            prestazioniAssegnate: prestazioniAssegnate,
            eccezioniListino: eccezioniListino,
            // 🆕 Categorie diagnostica refertabili
            categorieRefertazione: categorieRefertazione,
            // 🎯 NUOVI CAMPI INVIATI AL SALVATAGGIO
            paymentType,
            baseRate: paymentType === 'percentage' ? 0 : Number(baseRate),
            percentageExceptions: paymentType === 'percentage' ? [] : percentageExceptions
        });
    };

    const addException = () => {
        if (!newExceptionServiceId || !newExceptionPercentage) return;
        setEccezioniListino(prev => ({
            ...prev,
            [newExceptionServiceId]: parseFloat(newExceptionPercentage)
        }));
        setNewExceptionServiceId("");
        setNewExceptionPercentage("");
    };

    const removeException = (srvId) => {
        const updated = { ...eccezioniListino };
        delete updated[srvId];
        setEccezioniListino(updated);
    };

    return (
        <div style={modalStyles} onClick={onClose}>
            <div style={modalContentStyles} onClick={e => e.stopPropagation()}>
                <h3 style={{ borderBottom: '2px solid #f3f4f6', paddingBottom: '10px', marginTop: 0, color: '#1f2937' }}>
                    {doctorData ? 'Modifica Medico' : 'Nuovo Medico'}
                </h3>
                
                {/* TABS HEADER */}
                <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', borderBottom: '1px solid #e5e7eb' }}>
                    <button 
                        onClick={() => setActiveTab('base')} 
                        style={{ padding: '10px 15px', background: 'none', border: 'none', borderBottom: activeTab === 'base' ? '2px solid #2563eb' : '2px solid transparent', color: activeTab === 'base' ? '#2563eb' : '#6b7280', fontWeight: 'bold', cursor: 'pointer' }}
                    >
                        Dati Base
                    </button>
                    <button 
                        onClick={() => setActiveTab('clinico')} 
                        style={{ padding: '10px 15px', background: 'none', border: 'none', borderBottom: activeTab === 'clinico' ? '2px solid #2563eb' : '2px solid transparent', color: activeTab === 'clinico' ? '#2563eb' : '#6b7280', fontWeight: 'bold', cursor: 'pointer' }}
                    >
                        Profilo Clinico
                    </button>
                    <button 
                        onClick={() => setActiveTab('economico')}
                        style={{ padding: '10px 15px', background: 'none', border: 'none', borderBottom: activeTab === 'economico' ? '2px solid #2563eb' : '2px solid transparent', color: activeTab === 'economico' ? '#2563eb' : '#6b7280', fontWeight: 'bold', cursor: 'pointer' }} 
                    >
                        Economia
                    </button>
                </div>

                <div style={{ textAlign: 'left' }}>
                    {/* --- TAB: DATI BASE --- */}
                    {activeTab === 'base' && (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}><label style={labelStyle}>Nome</label><input type="text" value={firstName} onChange={e => setFirstName(e.target.value)} style={inputStyle}/></div>
                                <div style={{ flex: 1 }}><label style={labelStyle}>Cognome</label><input type="text" value={lastName} onChange={e => setLastName(e.target.value)} style={inputStyle}/></div>
                            </div>

                            <div>
                                <label style={labelStyle}>Email (necessaria per l'accesso all'App)</label>
                                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="es. dottore@clinica.it" style={inputStyle}/>
                            </div>

                            {/* 🆕 Aggiunto selettore colore */}
                            <div>
                                <label style={labelStyle}>Colore Agenda</label>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <input 
                                        type="color" 
                                        value={colore} 
                                        onChange={e => setColore(e.target.value)} 
                                        style={{ 
                                            width: '50px', height: '40px', padding: '0', 
                                            border: 'none', borderRadius: '8px', cursor: 'pointer',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                        }}
                                    />
                                    <span style={{ fontSize: '0.85rem', color: '#6b7280', fontWeight: '500' }}>
                                        Codice: {colore.toUpperCase()}
                                    </span>
                                </div>
                            </div>
                            
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}><label style={labelStyle}>Partita IVA</label><input type="text" value={pIva} onChange={e => setPIva(e.target.value)} style={inputStyle}/></div>
                                <div style={{ flex: 1 }}><label style={labelStyle}>IBAN (per bonifici compensi)</label><input type="text" value={iban} onChange={e => setIban(e.target.value)} style={inputStyle}/></div>
                            </div>

                            <div style={{ marginTop: '10px' }}>
                                <label style={labelStyle}>Associa Specialistiche</label>
                                <input type="text" placeholder="Cerca specialistiche..." value={searchTermSpec} onChange={e => setSearchTermSpec(e.target.value)} style={{...inputStyle, marginBottom: '10px'}} />
                                <div style={{ maxHeight: '150px', overflowY: 'auto', border: '1px solid #e5e7eb', borderRadius: '5px', padding: '10px', backgroundColor: '#f9fafb' }}>
                                    {[...allSpecialties].sort((a, b) => a.name.localeCompare(b.name)).filter(s => s.name.toLowerCase().includes(searchTermSpec.toLowerCase())).map(spec => (
                                        <label key={spec.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '5px 0', cursor: 'pointer' }}>
                                            <input type="checkbox" checked={selectedSpecialtyIds.includes(spec.id)} onChange={() => setSelectedSpecialtyIds(p => p.includes(spec.id) ? p.filter(id => id !== spec.id) : [...p, spec.id])} style={{ width: '16px', height: '16px' }}/>
                                            <span>{spec.name}</span>
                                        </label>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* --- TAB: PROFILO CLINICO E DIAGNOSTICA --- */}
                    {activeTab === 'clinico' && (
                        <fieldset disabled={isProfileMode} style={{ border: 'none', padding: 0, margin: 0 }}>
                            {isProfileMode && (
                                <div style={{ padding: '10px', backgroundColor: '#e0f2fe', color: '#1e3a8a', borderRadius: '8px', marginBottom: '15px', fontSize: '0.85rem' }}>
                                    ℹ️ I dati clinici e le prestazioni assegnate sono gestiti in sola lettura. Contatta la segreteria per eventuali modifiche.
                                </div>
                            )}
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', opacity: isProfileMode ? 0.8 : 1 }}>
                            
                            <label style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '12px', backgroundColor: isBookable ? '#eff6ff' : '#f3f4f6', border: isBookable ? '1px solid #bfdbfe' : '1px solid #e5e7eb', borderRadius: '8px', cursor: isProfileMode ? 'default' : 'pointer' }}>
                                <input type="checkbox" checked={isBookable} onChange={e => setIsBookable(e.target.checked)} style={{ width: '18px', height: '18px' }} />
                                <div>
                                    <div style={{ fontWeight: 'bold', color: isBookable ? '#1d4ed8' : '#4b5563' }}>Visibile in Agenda (Prenotabile)</div>
                                    <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>Se disabilitato, il medico non apparirà nel calendario.</div>
                                </div>
                            </label>

                            <div style={{ display: 'flex', gap: '15px', padding: '15px', backgroundColor: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                <div style={{ flex: 1 }}>
                                    <label style={labelStyle}>% Standard - Terapie Manuali</label>
                                    <div style={{ position: 'relative' }}><input type="number" min="0" max="100" value={percentualeManuale} onChange={e => setPercentualeManuale(e.target.value)} style={inputStyle} /><span style={{ position: 'absolute', right: '15px', top: '10px', color: '#9ca3af' }}>%</span></div>
                                </div>
                                <div style={{ flex: 1 }}>
                                    <label style={labelStyle}>% Standard - Strumentali</label>
                                    <div style={{ position: 'relative' }}><input type="number" min="0" max="100" value={percentualeStrumentale} onChange={e => setPercentualeStrumentale(e.target.value)} style={inputStyle} /><span style={{ position: 'absolute', right: '15px', top: '10px', color: '#9ca3af' }}>%</span></div>
                                </div>
                            </div>

                            <div>
                                <label style={labelStyle}>Quali prestazioni esegue questo medico?</label>
                                <div style={{ maxHeight: '180px', overflowY: 'auto', border: '1px solid #e5e7eb', borderRadius: '5px', padding: '10px', backgroundColor: '#f9fafb' }}>
                                    {allServices.length === 0 ? <span style={{fontSize:'0.8rem', color:'#6b7280'}}>Nessuna prestazione configurata nel centro.</span> : 
                                     [...allServices].sort((a, b) => a.nome.localeCompare(b.nome)).map(s => (
                                        <label key={s.id} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px', cursor: 'pointer' }}>
                                            <input type="checkbox" checked={prestazioniAssegnate.includes(s.id)} 
                                                onChange={e => setPrestazioniAssegnate(p => e.target.checked ? [...p, s.id] : p.filter(id => id !== s.id))} 
                                                style={{ width: '16px', height: '16px' }}
                                            />
                                            <span style={{ fontSize: '0.85rem' }}>{s.nome} <span style={{color: '#9ca3af', fontSize: '0.75rem'}}>({s.tipo || 'Manuale'})</span></span>
                                        </label>
                                    ))}
                                </div>
                            </div>

                            {/* ECCEZIONI LISTINO */}
                            <div style={{ padding: '15px', backgroundColor: '#fffbeb', border: '1px solid #fde68a', borderRadius: '8px' }}>
                                <h4 style={{ fontSize: '0.9rem', fontWeight: 'bold', color: '#92400e', margin: '0 0 5px 0' }}>🔥 Eccezioni Compensi</h4>
                                <p style={{ fontSize: '0.8rem', color: '#b45309', marginBottom: '10px' }}>Sovrascrivi la % standard per specifiche prestazioni.</p>
                                
                                <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                                    <select value={newExceptionServiceId} onChange={e => setNewExceptionServiceId(e.target.value)} style={{...inputStyle, flex: 2}}>
                                        <option value="">-- Seleziona Prestazione --</option>
                                        {allServices.map(s => <option key={s.id} value={s.id}>{s.nome}</option>)}
                                    </select>
                                    <input type="number" placeholder="% Med." value={newExceptionPercentage} onChange={e => setNewExceptionPercentage(e.target.value)} style={{...inputStyle, flex: 1}} />
                                    <button type="button" onClick={addException} style={{ padding: '0 15px', backgroundColor: '#d97706', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}>Add</button>
                                </div>

                                {Object.keys(eccezioniListino).length > 0 && (
                                    <ul style={{ listStyle: 'none', padding: 0, margin: 0, marginTop: '10px', fontSize: '0.85rem' }}>
                                        {Object.entries(eccezioniListino).map(([srvId, perc]) => (
                                            <li key={srvId} style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0', borderBottom: '1px solid #fde68a' }}>
                                                <span style={{ color: '#78350f', fontWeight: '500' }}>{allServices.find(s => s.id === srvId)?.nome || "Sconosciuta"}</span>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <strong style={{color: '#92400e'}}>{perc}%</strong>
                                                    <button type="button" onClick={() => removeException(srvId)} style={{background:'none', border:'none', color:'#dc2626', cursor:'pointer', display: 'flex'}}><X size={14}/></button>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>

                            {/* 🆕 ── SEZIONE CATEGORIE DIAGNOSTICA REFERTABILI ── */}
                            <div style={{ padding: '15px', backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '8px' }}>
                                <h4 style={{ fontSize: '0.9rem', fontWeight: 'bold', color: '#166534', margin: '0 0 5px 0' }}>
                                    🔬 Categorie Diagnostica Refertabili
                                </h4>
                                <p style={{ fontSize: '0.8rem', color: '#15803d', marginBottom: '12px' }}>
                                    Il sistema assegnerà automaticamente gli esami di queste categorie a questo medico in base alla sua disponibilità in struttura.
                                </p>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                    {[
                                        { value: 'ecografia',      label: 'Ecografia' },
                                        { value: 'rx',             label: 'Radiografia (RX)' },
                                        { value: 'tac',            label: 'TAC / TC' },
                                        { value: 'risonanza',      label: 'Risonanza Magnetica (RM)' },
                                        { value: 'analisi_sangue', label: 'Analisi del Sangue / Laboratorio' },
                                        { value: 'altro',          label: 'Altro' },
                                    ].map(cat => (
                                        <label
                                            key={cat.value}
                                            style={{
                                                display: 'flex', alignItems: 'center', gap: '10px',
                                                cursor: 'pointer', padding: '7px 10px', borderRadius: '6px',
                                                backgroundColor: categorieRefertazione.includes(cat.value) ? '#dcfce7' : 'transparent',
                                                border: categorieRefertazione.includes(cat.value) ? '1px solid #86efac' : '1px solid transparent',
                                                transition: 'all 0.15s'
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={categorieRefertazione.includes(cat.value)}
                                                onChange={() =>
                                                    setCategorieRefertazione(prev =>
                                                        prev.includes(cat.value)
                                                            ? prev.filter(v => v !== cat.value)
                                                            : [...prev, cat.value]
                                                    )
                                                }
                                                style={{ width: '16px', height: '16px' }}
                                            />
                                            <span style={{ fontSize: '0.875rem' }}>{cat.label}</span>
                                        </label>
                                    ))}
                                </div>
                            </div>
                            </div>
                        </fieldset>
                    )}

                    {/* --- 🎯 TAB: ECONOMIA --- */}
                    {activeTab === 'economico' && (
                        <fieldset disabled={isProfileMode} style={{ border: 'none', padding: 0, margin: 0 }}>
                            {isProfileMode && (
                                <div style={{ padding: '10px', backgroundColor: '#e0f2fe', color: '#1e3a8a', borderRadius: '8px', marginBottom: '15px', fontSize: '0.85rem' }}>
                                    ℹ️ I modelli di compenso e i bonus sono visualizzati in sola lettura.
                                </div>
                            )}
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', opacity: isProfileMode ? 0.8 : 1 }}>
                            <div>
                                <label style={labelStyle}>Modello di Compenso Principale</label>
                                <select 
                                    style={inputStyle} 
                                    value={paymentType} 
                                    onChange={(e) => setPaymentType(e.target.value)}
                                >
                                    <option value="percentage">Solo a Percentuale (Standard)</option>
                                    <option value="hourly">Compenso a Ore (su Turni Master) + Bonus %</option>
                                    <option value="fixed">Fisso Mensile + Bonus %</option>
                                </select>
                            </div>

                            {paymentType !== 'percentage' && (
                                <div style={{ padding: '15px', backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px' }}>
                                    <label style={labelStyle}>
                                        {paymentType === 'hourly' ? "Tariffa Oraria Lorda (€)" : "Compenso Fisso Mensile Lordo (€)"}
                                    </label>
                                    <input 
                                        type="number" 
                                        min="0" step="0.01" 
                                        style={inputStyle} 
                                        value={baseRate} 
                                        onChange={(e) => setBaseRate(e.target.value)} 
                                        placeholder={paymentType === 'hourly' ? "Es. 35.00" : "Es. 1500.00"}
                                    />
                                    
                                    <div style={{ marginTop: '20px' }}>
                                        <label style={labelStyle}>Seleziona Prestazioni "Eccezione" (Bonus a Percentuale)</label>
                                        <p style={{ fontSize: '0.75rem', color: '#64748b', marginBottom: '10px' }}>
                                            Se il medico esegue queste prestazioni, riceverà la sua percentuale calcolata sull'importo della prestazione, <strong>in aggiunta</strong> al suo compenso base.
                                        </p>
                                        <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #d1d5db', borderRadius: '6px', padding: '10px', backgroundColor: 'white' }}>
                                            {allServices.map(srv => (
                                                <label key={srv.id} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', cursor: 'pointer' }}>
                                                    <input 
                                                        type="checkbox" 
                                                        checked={percentageExceptions.includes(srv.id)}
                                                        onChange={() => {
                                                            setPercentageExceptions(prev => 
                                                                prev.includes(srv.id) ? prev.filter(id => id !== srv.id) : [...prev, srv.id]
                                                            );
                                                        }}
                                                    />
                                                    <span style={{ fontSize: '0.85rem' }}>{srv.nome}</span>
                                                </label>
                                            ))}
                                            {allServices.length === 0 && <span style={{ fontSize: '0.8rem', color: '#94a3b8' }}>Nessuna prestazione trovata.</span>}
                                        </div>
                                    </div>
                                </div>
                            )}
                            </div>
                        </fieldset>
                    )}
                </div>

                {/* BOTTONI DI SALVATAGGIO */}
                <div style={{ display: 'flex', gap: '10px', marginTop: '25px' }}>
                    <button onClick={handleSave} className="modal-button confirm-button" style={{ flex: 1 }}>{doctorData ? 'Salva Modifiche' : 'Crea Medico'}</button>
                    <button onClick={onClose} className="modal-button cancel-button">Annulla</button>
                </div>
            </div>
        </div>
    );
}